module.exports = {"id":"205391","name":"Soualiho Meïté","rating":"75","photo":"./data/images/photos/3/205391.png","club":{"name":"Girondins de BX","logo":"./data/images/clubs/GirondinsdeBX.png"},"positions":["MDC","MC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SoualihoMeite0.json
// module id = 3995
// module chunks = 0